import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";

export class VirtualShelfControl {
  constructor() {
    this.currentResource = null;
    this.resources = [];

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onGetVirtualShelfResources, (event) =>
      this.getVirtualShelfResources(event)
    );
  }

  getBranchFilters() {
    var branchToUse = ApplicationData.getBranchToUseForAvailability();

    if (branchToUse) {
      return [branchToUse];
    }
    return ApplicationData.branchLimitsUtil.getLimitedBranches();
  }

  getVirtualShelfResources(event) {
    var resources = [];
    var success = false;
    var currentResource = event.resource;
    var endOfLeftList = false;
    var endOfRightList = false;

    var postData = {
      resourceId: currentResource.id,
      leftRange: 5,
      rightRange: 5,
      branchFilters: this.getBranchFilters(),
    };

    TLCRest.jsonCall("virtualShelf/browse", {
      callback: function (event) {
        resources = event.resources;
        endOfLeftList = event.endOfLeftList;
        endOfRightList = event.endOfRightList;
        success = true;
      },
      finallyHandler: function () {
        TLCEvents.trigger(
          LS2PAC_CONSTANTS.Events.onGetVirtualShelfResourcesResponse,
          {
            endOfLeftList: endOfLeftList,
            endOfRightList: endOfRightList,
            resources: resources,
            success: success,
          }
        );
      },
      timeout: 60000,
      postData: postData,
      cancellable: true,
    });
  }
}
